import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tab-general',
  templateUrl: './tab-general.component.html',
  styleUrls: ['./tab-general.component.scss'],
})
export class TabGeneralComponent implements OnInit {

  @Input()
  locationSectorForm: FormGroup;

  @Input()
  isViewMode: boolean;

  constructor(
  ) {}

  ngOnInit(): void {
  }
}
